/**
 * The published pages this app hands the trainer out to — support, terms, privacy.
 *
 * Copied VERBATIM from the mobile app's `src/shared/lib/legalDocuments.ts`, which is the address
 * book both clients read. Two things about the addresses are worth knowing before editing one:
 * there is exactly one set of documents across every environment, so they are literals rather than
 * `VITE_*` configuration; and the `.html` suffix is load-bearing, because the marketing site is
 * served as static files with no extensionless routing and `/kontakt` answers 404.
 *
 * The privacy page is `polityka-prywatnosci.html`, which is not guessable from the other two.
 */

export interface LegalLink {
  /** Identifies the row to React and picks the label. */
  readonly id: 'support' | 'terms' | 'privacy';
  /** Key in the web-only bundle — `web:account.app.help.<id>`. */
  readonly labelKey: string;
  readonly url: string;
}

export const LEGAL_LINKS: readonly LegalLink[] = [
  { id: 'support', labelKey: 'web:account.app.help.support', url: 'https://movebuddy.pl/kontakt.html' },
  { id: 'terms', labelKey: 'web:account.app.help.terms', url: 'https://movebuddy.pl/regulamin.html' },
  {
    id: 'privacy',
    labelKey: 'web:account.app.help.privacy',
    url: 'https://movebuddy.pl/polityka-prywatnosci.html',
  },
];

/** The address of one document, for a caller that links to it outside the help list. */
export function legalUrl(id: LegalLink['id']): string {
  const link = LEGAL_LINKS.find((candidate) => candidate.id === id);
  if (link === undefined) throw new Error(`No legal link for ${id}`);
  return link.url;
}
